import React, { useEffect, useMemo, useState } from "react";
import TabMenu from "../common/tabMenu";
import Feed from "./community/feed";
import Blog from "./community/blog";
import { useLocation, useOutletContext } from "react-router";
import { useModal } from "../../../../hooks/useModal";
import Write from "./community/write";

const tabs = [
  { label: "피드", key: "feed" },
  { label: "친구 소식", key: "blog" },
];

const GroupCommunity = () => {
  const locaion = useLocation();
  const { modal, openModal, closeModal } = useModal();
  const [active, setActive] = useState(0);
  const { group, member } = useOutletContext();

  useEffect(() => {
    const navigationState = locaion?.state;
    if (navigationState) {
      setActive(tabs.findIndex((tab) => tab.key === navigationState?.type) || 0);
    }
  }, []);

  const tabChange = (idx) => {
    setActive(idx);
  };

  const currentComponent = useMemo(() => {
    switch (active) {
      case 0:
        return <Feed openModal={openModal} closeModal={closeModal} group={group} />;
      case 1:
        return <Blog />;
      case 2:
        return (
          <Write
            group={group}
            member={member}
            openModal={openModal}
            closeModal={closeModal}
            active={active}
            setActive={setActive}
          />
        );
      default:
        return null;
    }
  }, [active, group, member]);

  return (
    <>
      {modal}
      <TabMenu tabChange={tabChange} tabs={tabs} active={active} isCreate={true} />
      {currentComponent}
    </>
  );
};

export default GroupCommunity;
